"use client";

import { c as _c } from "react/compiler-runtime";
import { Switch as MantineSwitch } from "@mantine/core";
import styles from "./switch.module.css";
export type SwitchProps = Readonly<{
  checked: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel?: string;
  disabled?: boolean;
}>;
export function Switch(t0) {
  const $ = _c(8);
  const {
    checked,
    onChange,
    ariaLabel,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== onChange) {
    t2 = event => onChange(event.currentTarget.checked);
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      root: styles.root
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== ariaLabel || $[4] !== checked || $[5] !== disabled || $[6] !== t2) {
    t4 = <MantineSwitch checked={checked} onChange={t2} aria-label={ariaLabel} disabled={disabled} withThumbIndicator={false} classNames={t3} />;
    $[3] = ariaLabel;
    $[4] = checked;
    $[5] = disabled;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}